<div [ngSwitch]="activeTab$ | async">
  <div *ngSwitchCase="'schedule'">
    <div class="card mb-3 surface-card border-round shadow-1 p-3" style="border: 1px solid var(--surface-200)">
      <div class="flex justify-content-between align-items-center">
        <div class="flex align-items-center">
          <i class="pi pi-box mr-2"></i>
          <span class="font-bold mr-1">Total Orders Today:</span> {{ getTotalOrdersForDay(this.today) }}
        </div>
        <div>
          <h2 class="m-0">{{ this.drivername }}'s Weekly Schedule</h2>
        </div>
        <div>
          <span class="font-bold">Week's Deliveries:</span> {{ getWeeklyTotal() }}
        </div>
      </div>
    </div>


    <!-- Main Calendar Container -->
    <div class="calendar-container flex flex-grow-1 justify-content-center align-items-center border-round p-2 shadow-2"
      style="gap: 1rem; min-height: 50vh; max-width: 100%;">

      <!-- Left Arrow -->
      <button pButton icon="pi pi-chevron-left" class="p-button-rounded p-button-text" (click)="previousDay()">
      </button>

      <!-- Days Container -->
      <div class="days-container flex gap-2 flex-grow-1 justify-content-between">
        <!-- Loop through the last 7 days -->
        <div *ngFor="let day of lastSevenDays" [ngClass]="{'today-highlight': isToday(day)}"
          class="calendar-day surface-card border-round shadow-1 p-2"
          style="width: calc(14% - 8px); min-height: 45vh; text-align: center;">
          <!-- Day Header -->
          <div class="day-header mb-3 pb-2 border-bottom-1 surface-border">
            <div class="text-900 font-semibold text-lg">{{ day | date: 'EEE' }}</div>
            <div class="text-600">{{ day | date: 'MMM dd' }}</div>
          </div>

          <!-- Orders List -->
          <div class="orders-container" style="overflow-y: auto; max-height: calc(45vh - 80px);">
            <div *ngFor="let order of getOrdersForDay(day)"
              class="order-item p-2 mb-2 border-round surface-100 text-left text-sm"
              (click)="moreOrderInfo(order.order_id)">
              <div class="flex flex-column gap-2">
                <div class="flex flex-column">
                  <strong>Supplier:</strong>
                  <span>{{ getCustomerName(order.supplier_id) }}</span>
                </div>
                <div class="flex flex-column">
                  <strong>Receiver:</strong>
                  <span>{{ getCustomerName(order.receiver_id) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Arrow -->
      <button pButton icon="pi pi-chevron-right" class="p-button-rounded p-button-text" (click)="nextDay()">
      </button>
    </div>

    <!-- Driver Charts components -->
    <app-drivers-charts [lastSevenDays]="lastSevenDays" [driverId]="driverId"
      [getTotalOrdersForDay]="getTotalOrdersForDay.bind(this)"
      [getDeliveredOrdersForDay]="getDeliveredOrdersForDay.bind(this)"></app-drivers-charts>
  </div>

  <div *ngSwitchCase="'notes'">
    <!-- Notes content -->
    <app-drivers-notes [driverId]="driverId"></app-drivers-notes>
  </div>
</div>